//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'SearchExcursions',
  components: {
    ExcursionCard: () => import('@/components/common/ExcursionCard'),
    Button: () => import('@/components/common/Button'),
    HorizontalEntityCard: () => import('@/components/common/HorizontalEntityCard')
  },
  data () {
    return {
      count: 3,
      page: 1
    }
  },
  computed: {
    show () {
      return this?.excursions?.length > 0 && this?.page < this?.excursionsMeta?.last_page
    },
    excursions () {
      return this.$store.getters['search/excursions']
    },
    excursionsMeta () {
      return this.$store.getters['search/excursionsMeta']
    }
  },
  methods: {
    next () {
      this.page += 1
      this.$store.dispatch('search/excursions', {
        params: {
          resolution: 'medium',
          query: this.$route.query.search,
          page: this.page,
          count: this.count
        }
      })
    }
  }
}
